<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="LAW_ID"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="lawId"
            label="법령"
            v-model="searchParam.lawId"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-field
            type="user"
            label="담당자"
            name="userId"
            v-model="searchParam.userId" />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="법령담당자 목록"
      tableId="equipmentInsp"
      :columns="grid.columns"
      :data="grid.data"
      :checkClickFlag="false"
      rowKey="seniorId"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group>
            <c-btn label="검색" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'users'">
          <c-tag 
            :editable="editable"
            icon="person_outline"
            itemText="userName"
            itemValue="check"
            name="users" 
            v-model="props.row.users"
            @addTag="addManager(props.row)"
            @removeTag="item => removeManager(item)"
          />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: "law-manager",
    data() {
    return {
      grid: {
        columns: [
          {
            name: 'lawName',
            field: 'lawName',
            label: '법령',
            align: 'left',
            style: 'width:400px',
            sortable: true,
          },
          {
            name: 'users',
            field: 'users',
            label: '담당자',
            align: 'left',
            type: 'custom',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        lawId: null,
        userId: null,
      },
      row: null,
      editable: true,
      listUrl: '',
      insertUrl: '',
      deleteUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.lawManager.list.url
      this.insertUrl = transactionConfig.mdm.lawManager.insert.url;
      this.deleteUrl = transactionConfig.mdm.lawManager.delete.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    addManager(row) {
      this.row = this.$_.clone(row)
      this.popupOptions.title = '사용자 검색'; // 사용자 검색
      this.popupOptions.param = {
        type: 'multiple'
      };
      this.popupOptions.target = () => import(`${'@/pages/common/user/userPop.vue'}`);
      this.popupOptions.width = '60%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        let saveData = [];
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.row.users, { userId: item.userId }) === -1) {
            this.$set(item, 'lawId', this.row.lawId)
            saveData.push(item)
          }
        })
        this.$http.url = this.insertUrl;
        this.$http.type = 'POST';
        this.$http.param = saveData;
        this.$http.request((_result) => {
          window.getApp.$emit('APP_REQUEST_SUCCESS');
          this.getList();
        },);
      }
    },
    removeManager(item) {
      this.$http.url = this.$format(this.deleteUrl, item.mdmLawManagerId);
      this.$http.type = 'DELETE';
      this.$http.request((_result) => {
        window.getApp.$emit('APP_REQUEST_SUCCESS');
        this.getList();
      },);
    }
  },
};
</script>
